module.exports = __webpack_public_path__ + "static/media/aceton_3.af391ac9.png";